import { useContext } from 'react';
import { PaymentsContext } from '../context/PaymentContext';

export const usePaymentsContext = () => {
	const context = useContext(PaymentsContext);

	if (!context) {
		throw Error(
			'usePaymentsContext must be used within a PaymentsContextProvider'
		);
	}

	return context;
};
